module.exports = __webpack_public_path__ + "static/img/b3_footer.5b48f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b3_footer.png
// module id = cbJr
// module chunks = 1